import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { TextArea } from '@delmonicos/shared-design-system-react/src/components/text-area/text-area.component';
import { useCreateTicketFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tickets/models/inputs/create-ticket.form-validation';
import { CreateTicketModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/support-service-lib/src/wrapper/inputs/create-ticket.model';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AssigneeSelectionComponent } from '../../shared/assignee-selection/assignee-selection.component';
import { useTicketContext } from '../../ticket.context';
import { useTicketScope } from '../use-ticket-scope.hook';

export const TicketUpdateFormStep1Controller = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { control } = useFormContext<CreateTicketModel>();
  const { title, description } = useCreateTicketFormValidation();
  const scope = useTicketScope(useTicketContext());

  return (
    <Card flex={1} direction="column" gap={GapEnum.L}>
      <Controller
        name="title"
        control={control}
        rules={title}
        render={({ field, fieldState: { error } }) => (
          <TextInput
            label={t('delmonicos-shared-sdk.inputs-create-ticket.title')}
            placeholder={t('delmonicos-shared-sdk.inputs-create-ticket.title')}
            required={!!title.required}
            errorMessage={error?.message}
            {...field}
            value={field.value ?? ''}
          />
        )}
      />
      <Controller
        name="description"
        control={control}
        rules={description}
        render={({ field, fieldState: { error } }) => (
          <TextArea
            label={t('delmonicos-shared-sdk.inputs-create-ticket.description')}
            placeholder=""
            required={!!description.required}
            errorMessage={error?.message}
            {...field}
            value={field.value ?? ''}
          />
        )}
      />
      <Controller
        name="assigneeId"
        control={control}
        render={(props) => (
          <AssigneeSelectionComponent
            {...props}
            clearable={false}
            scope={scope}
          />
        )}
      />
    </Card>
  );
};
